import axios from "axios";
import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../utils/queryParams.js";
import moment from "moment";

export const SET_LOADING = "saga/SET_LOADING";
export const TOGGLE_OFFERS = "saga/TOGGLE_OFFERS";
export const SET_DATES = "saga/SET_DATES";
export const UPDATE_DATES = "saga/UPDATE_DATES";
export const SET_FILTERS_LOADING = "saga/SET_FILTERS_LOADING";
export const UPDATE_CUSTOM_RANGE = "saga/UPDATE_CUSTOM_RANGE";

export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CONVERSION_VALUES = "saga/FETCH_CONVERSION_VALUES";
export const FETCH_CONVERSION_VALUES_SUCCESS = "saga/FETCH_CONVERSION_VALUES_SUCCESS";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateDates: createAction(UPDATE_DATES),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE)
};
export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
}

export function* getCurrentUserData(data) {
  // Get user data first. Once we confirm we have user data pass to other sagas and call them.
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: SET_FILTERS_LOADING, payload: true });
  yield put({ type: TOGGLE_OFFERS, payload: false });
  const { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);
  let { calendarEndDate } = data.payload.data;
  let endDate;
  let startDate;
  let excludeIntros = false;

  if (data.payload.updateFilters || data.payload.toggleOffers) {
    startDate = yield select((state) => state.firstVisitConversion.selectedRequestDates.startDate);
    endDate = yield select((state) => state.firstVisitConversion.selectedRequestDates.endDate);

    if (data.payload.toggleOffers) {
      excludeIntros = true;
      yield put({ type: TOGGLE_OFFERS, payload: true });
    }
  } else {
    startDate = moment(calendarEndDate).startOf("month").format("YYYY-MM-DD");
    endDate = calendarEndDate;

    yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: data.payload.data });
    yield put({ type: SET_DATES, payload: { startDate: startDate, endDate: endDate } });
  }

  yield getConversionData({
    organization_id,
    short_url,
    start_date: startDate,
    end_date: endDate,
    limit: 100,
    exclude_intros: excludeIntros
  });
}

function* getConversionData(params) {
  try {
    const res = yield call(
      axios.get,
      queryParams.apiVersion + "pages/retention/first_visits_conversion/get_conversion_values",
      { params }
    );

    yield put({ type: FETCH_CONVERSION_VALUES_SUCCESS, payload: res.data });
  } catch (error) {
    console.error(error);
  }
}
